import { Link } from 'react-router-dom';
import { collections } from '@/mocks/collections';
import { getComicById } from '@/lib/comics';

export default function CollectionSection() {
  return (
    <section className="w-full">
      <div className="flex items-end justify-between mb-5 gap-4">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">推荐专题合集</h2>
          <p className="mt-1 text-sm text-foreground-600">小编精选策划，一次看个够</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {collections.map((col, i) => (
          <Link
            key={col.id}
            to={`/category/${getComicById(col.comicIds[0])?.categories[0] ?? 'romance'}`}
            className={`group relative block rounded-lg overflow-hidden border border-background-200 cursor-pointer ${
              i === 0 ? 'lg:col-span-2 h-[260px] md:h-[320px]' : 'h-[220px]'
            }`}
          >
            <img
              src={col.cover}
              alt={`${col.title} 韩漫专题合集`}
              title={`${col.title} 韩漫专题推荐`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-transparent"></div>
            <div className="absolute inset-0 p-5 md:p-7 flex flex-col justify-end">
              <span className="self-start px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-label font-medium mb-2">
                {col.subtitle}
              </span>
              <h3 className={`font-heading font-bold text-background-50 ${i === 0 ? 'text-2xl md:text-3xl' : 'text-xl'}`}>
                {col.title}
              </h3>
              <p className="mt-2 text-sm text-background-100/90 line-clamp-2 max-w-xl">{col.description}</p>
              <div className="mt-3 flex items-center gap-2 text-xs text-background-200/90 font-label">
                <i className="ri-stack-line text-accent-300"></i>
                共 {col.comicIds.length} 部作品
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}